// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brush-size-slider {
    display: inline-block;
    width: 150px;
}

.vertical-radio-buttons {
    display: block;
    height: 30px;
    line-height: 30px;
}

.top-child-vertical-radio-buttons {
    border-radius: 4px 4px 0 0 !important;
}

.bottom-child-vertical-radio-buttons {
    border-radius: 0 0 4px 4px !important;
}

.scan-settings-box-left {
    padding: 20px;
    border: 1px solid black;
    border-radius: 10px 0 0 10px;
}

.scan-settings-box-right {
    padding: 20px;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
    border-top: 1px solid black;
    border-radius: 0 10px 10px 0;
}

.scan-settings-parent { /* Safari */		
	display: flex; /* Standard syntax */
}

.z-stack-scan-input-field {
    width: 80%;
}

.z-stack-scan-text {
    margin-top: 5px;
}

.relative-parent {
    position: relative;
    height: 80vh;
}

.save-changes-row {
    position: absolute;
    bottom: 0;
    width: 100%;
}

.properties-width {
    height: 86vh;
}

.tab-section-height {
    height: 82vh;
    background-color: rgb(227, 233, 231);
    padding-left: 10px !important;
    border: 1px solid rgb(227, 233, 231);
    border-radius: 5px;
}

.tab-section-height .ant-tabs-bar {
    border-bottom: 1px solid white;
}

.save-button-height {
    height: 4vh;
    margin-top: 10px;
}

.center {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.divider-style {
    background-color: #e8e8e8;
}

.side-panel-section {
    margin-bottom: 15px;
}

.react-region-select-custom--style > div > div > div[data-dir=se] {
    width: 20px !important;
    height: 20px !important;
    bottom: -8px !important;
    right: -8px !important;
}

.react-region-select-custom--style > div > div > div[data-dir=sw] {
    width: 20px !important;
    height: 20px !important;
    bottom: -8px !important;
    left: -8px !important;
}

.react-region-select-custom--style > div > div > div[data-dir=nw] {
    width: 20px !important;
    height: 20px !important;
    top: -8px !important;
    left: -8px !important;
}

.react-region-select-custom--style > div > div > div[data-dir=ne] {
    width: 20px !important;
    height: 20px !important;
    top: -8px !important;
    right: -8px !important;
}

.react-region-select-custom--style > div > div > div[data-dir=se] {
    width: 20px !important;
    height: 20px !important;
    bottom: -8px !important;
    right: -8px !important;
}

.react-region-select-custom--style > div > div > div[data-dir=n] {
    width: 15px !important;
    height: 15px !important;
    top: -8px !important;
    left: 45% !important;
}

.react-region-select-custom--style > div > div > div[data-dir=e] {
    width: 15px !important;
    height: 15px !important;
    top: 45% !important;
    right: -8px !important;
}

.react-region-select-custom--style > div > div > div[data-dir=w] {
    width: 15px !important;
    height: 15px !important;
    top: 45% !important;
    left: -8px !important;
}

.react-region-select-custom--style > div > div > div[data-dir=s] {
    width: 15px !important;
    height: 15px !important;
    bottom: -8px !important;
    left: 45% !important;
}

.selected-area-component {
    font-size: 15px; 
    font-weight: bold; 
    text-align: center;
    padding-top: 10px;
}

/* antd css changes for scanner workflow only */

.ant-slider-track {
    background-color: rgba(0, 0, 0, 0.6) !important;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/workflow/slot-component.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,8BAA8B;IAC9B,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA,wBAAwB,WAAW;CAClC,aAAa,EAAE,oBAAoB;AACpC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,oCAAoC;IACpC,6BAA6B;IAC7B,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,+CAA+C;;AAE/C;IACI,+CAA+C;AACnD","sourcesContent":[".brush-size-slider {\n    display: inline-block;\n    width: 150px;\n}\n\n.vertical-radio-buttons {\n    display: block;\n    height: 30px;\n    line-height: 30px;\n}\n\n.top-child-vertical-radio-buttons {\n    border-radius: 4px 4px 0 0 !important;\n}\n\n.bottom-child-vertical-radio-buttons {\n    border-radius: 0 0 4px 4px !important;\n}\n\n.scan-settings-box-left {\n    padding: 20px;\n    border: 1px solid black;\n    border-radius: 10px 0 0 10px;\n}\n\n.scan-settings-box-right {\n    padding: 20px;\n    border-right: 1px solid black;\n    border-bottom: 1px solid black;\n    border-top: 1px solid black;\n    border-radius: 0 10px 10px 0;\n}\n\n.scan-settings-parent { /* Safari */\t\t\n\tdisplay: flex; /* Standard syntax */\n}\n\n.z-stack-scan-input-field {\n    width: 80%;\n}\n\n.z-stack-scan-text {\n    margin-top: 5px;\n}\n\n.relative-parent {\n    position: relative;\n    height: 80vh;\n}\n\n.save-changes-row {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n}\n\n.properties-width {\n    height: 86vh;\n}\n\n.tab-section-height {\n    height: 82vh;\n    background-color: rgb(227, 233, 231);\n    padding-left: 10px !important;\n    border: 1px solid rgb(227, 233, 231);\n    border-radius: 5px;\n}\n\n.tab-section-height .ant-tabs-bar {\n    border-bottom: 1px solid white;\n}\n\n.save-button-height {\n    height: 4vh;\n    margin-top: 10px;\n}\n\n.center {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n}\n\n.divider-style {\n    background-color: #e8e8e8;\n}\n\n.side-panel-section {\n    margin-bottom: 15px;\n}\n\n.react-region-select-custom--style > div > div > div[data-dir=se] {\n    width: 20px !important;\n    height: 20px !important;\n    bottom: -8px !important;\n    right: -8px !important;\n}\n\n.react-region-select-custom--style > div > div > div[data-dir=sw] {\n    width: 20px !important;\n    height: 20px !important;\n    bottom: -8px !important;\n    left: -8px !important;\n}\n\n.react-region-select-custom--style > div > div > div[data-dir=nw] {\n    width: 20px !important;\n    height: 20px !important;\n    top: -8px !important;\n    left: -8px !important;\n}\n\n.react-region-select-custom--style > div > div > div[data-dir=ne] {\n    width: 20px !important;\n    height: 20px !important;\n    top: -8px !important;\n    right: -8px !important;\n}\n\n.react-region-select-custom--style > div > div > div[data-dir=se] {\n    width: 20px !important;\n    height: 20px !important;\n    bottom: -8px !important;\n    right: -8px !important;\n}\n\n.react-region-select-custom--style > div > div > div[data-dir=n] {\n    width: 15px !important;\n    height: 15px !important;\n    top: -8px !important;\n    left: 45% !important;\n}\n\n.react-region-select-custom--style > div > div > div[data-dir=e] {\n    width: 15px !important;\n    height: 15px !important;\n    top: 45% !important;\n    right: -8px !important;\n}\n\n.react-region-select-custom--style > div > div > div[data-dir=w] {\n    width: 15px !important;\n    height: 15px !important;\n    top: 45% !important;\n    left: -8px !important;\n}\n\n.react-region-select-custom--style > div > div > div[data-dir=s] {\n    width: 15px !important;\n    height: 15px !important;\n    bottom: -8px !important;\n    left: 45% !important;\n}\n\n.selected-area-component {\n    font-size: 15px; \n    font-weight: bold; \n    text-align: center;\n    padding-top: 10px;\n}\n\n/* antd css changes for scanner workflow only */\n\n.ant-slider-track {\n    background-color: rgba(0, 0, 0, 0.6) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
